import axios from 'axios';
import { AppFunctions } from '../component/base/App';
import { DbUtils } from '../utils/DbUtils';
import { ErrorUtils } from '../utils/ErrorUtils';

/**
 * ログインを管理するserviceクラス
 */
export class LoginService {

	/** APP function */
	private appFunctions: AppFunctions;

	constructor(appFunctions: AppFunctions) {
		this.appFunctions = appFunctions;
	}

	/**
	 * ログインを行う。
	 * 
	 * @param username 
	 * @param password 
	 * @returns 
	 */
	async login(username: string, password: string): Promise<void> {

		try {
			const res = await DbUtils.getLoginApi().login({
				username: username,
				password: password,
			});

			axios.defaults.headers.common["Authorization"] = res.data.idToken!;
			this.appFunctions.setLogin(res.data);

		} catch (error: any) {
			// 認証エラーの場合、
			if (error.response != undefined && (error.response as Response).status == 403) {
				alert(`認証に失敗しました。\n\n${error.response.data}`);
				return;
			}
			// それ以外のエラーの場合、
			if (error instanceof Error) {
				alert(`以下のエラーが発生しました。\n\n${error.name}: ${error.message}`);
			} else {
				alert('予期せぬエラーが発生しました。');
			}
		}
	}

	/**
	 * ログアウトを行う。
	 * 
	 * @param refreshToken 
	 */
	async logout(refreshToken?: string): Promise<void> {
		try {
			await DbUtils.getLoginApi().logout({ refreshToken: refreshToken });
		} finally {
			(axios.defaults.headers.common as Record<string, string | undefined>)["Authorization"] = undefined;
			this.appFunctions.setLogin(undefined);
		}
	}

	/**
	 * IDトークンの更新を行う。
	 * 
	 * @param refreshToken 
	 */
	async refresh(refreshToken?: string): Promise<void> {
		try {
			const res = await DbUtils.getLoginApi().refreshToken({ refreshToken: refreshToken });
			axios.defaults.headers.common["Authorization"] = res.data.idToken!;
			const login = this.appFunctions.getLogin();
			if (login != undefined) {
				login.accessToken = res.data.accessToken;
				this.appFunctions.setLogin(login);
			}
		} catch (error: any) {
			// 認証エラーの場合、
			if (error.response != undefined && (error.response as Response).status == 403) {
				(axios.defaults.headers.common as Record<string, string | undefined>)["Authorization"] = undefined;
				this.appFunctions.setLogin(undefined);
			}
		}
	}

	/**
	 * パスワードを変更する。
	 
	 * @param oldPassword 
	 * @param newPassword 
	 * @returns 
	 */
	async changePassword(oldPassword: string, newPassword: string): Promise<boolean> {
		const login = this.appFunctions.getLogin();
		if (login == undefined) {
			alert('セッション情報を取得できませんでした。\nログインしなおしてください。');
			return false;
		}

		try {
			await DbUtils.getLoginApi().changePassword({
				oldPassword: oldPassword,
				newPassword: newPassword,
				accessToken: login.accessToken,
			});
			alert('パスワードを変更しました。');
			return true;
		} catch (error) {
			ErrorUtils.alert(error);
			return false;
		}
	}

	/**
	 * パスワードを再発行する。
	 * 
	 * @param username 
	 * @param email 
	 * @returns 
	 */
	async reissuePassword(username: string, email: string): Promise<boolean> {

		try {
			await DbUtils.getLoginApi().reissuePassword({
				username: username,
				email: email,
			});
			alert('パスワードを再発行して、メールで通知いたしました。');
			return true;
		} catch (error) {
			ErrorUtils.alert(error);
			return false;
		}
	}
}